/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {ListGroupItem , Thumbnail , ListGroup  ,  Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import CDNImage from '../components/media/image.js';
import CDNAudio from '../classes/audio.js';
import Config from '../classes/config.js';
import ContentService from '../services/content-service.js';
import ContentStore   from '../store/content-store.js';
import ContentModel   from './content-edit-model.js';
import Environment    from '../constants/environment.js';
import { FormattedMessage } from 'react-intl';

export default  class VocabCreate  extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            vocabObject:this.props.vocab,
            catalog:ContentStore.getCatalog(this.props.catalogUID),
        }
        this.base = Config.getBaseUrl();
        this.baseAudio = Config.getAudioBaseUrl();
    }

    componentDidMount() {
        this.baseUrl = Config.getBaseUrl();
        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.props.catalogUID)
            })

        });
    }

    componentWillReceiveProps(props){

        if(!props.vocabObject) return ;

        if(JSON.stringify(this.state.vocabObject) != JSON.stringify(props.vocabObject))
        {
            this.setState({vocabObject:props.vocabObject})
        }

    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }


    addVocab(){

        if(!this.hasBeenAdded())
        {
            ContentService.addVocab(this.props.catalogUID , this.props.vocab.uid).then(function(){
                ContentService.fetchCatalog(this.props.catalogUID);
                ContentService.fetchCatalogSummary(this.props.catalogUID);
            }.bind(this));
        }
        else
        {
            ContentService.removeVocab(this.props.catalogUID , this.props.vocab.uid).then(function(){
                ContentService.fetchCatalog(this.props.catalogUID);
                ContentService.fetchCatalogSummary(this.props.catalogUID);
            }.bind(this));
        }
    }

    hasBeenAdded(){

        for(let idx = 0 ;  idx < this.state.catalog.vocab.length; idx++)
        {
            if(this.state.catalog.vocab[idx].uid == this.props.vocab.uid) return true;
        }

        return false;
    }

    vocabModelToggle(){
        this.setState({show:!this.state.show});
    }

    render()
    {
        console.log(this.props.vocab.audio)
        let buttons =  [<Button onClick={this.vocabModelToggle.bind(this , true)} bsStyle="default" block>
            <FormattedMessage id={"ui-663"} defaultMessage={"Edit"} /></Button>, <Button onClick={this.addVocab.bind(this)} bsStyle={!this.hasBeenAdded() ? "primary" : "danger"} block>{!this.hasBeenAdded() ? <FormattedMessage id={"ui-2224"} defaultMessage={"Add"} />: <FormattedMessage id={"ui-445"} defaultMessage={"Remove"} />}</Button>]



        return <Thumbnail className="p-t-20" src={this.base+"vocabs/"+this.props.vocab.picture} alt="242x200">
            <ListGroup>
                <ContentModel imagePreviewUrl={this.base+"vocabs/"+this.props.vocab.picture} vocabUID={this.props.vocab.uid} supportAudio={this.baseAudio+this.props.vocab.audio} learningAudio={this.baseAudio+this.props.vocab.learningAudio} supportWord={this.props.vocab.originalWord} learningWord={this.props.vocab.word} catalogUID={this.props.catalogUID} show={this.state.show} onToggle={this.vocabModelToggle.bind(this)} />

                <ListGroupItem>{this.props.vocab.word}    <span className="pull-right" onClick={this.playAudio.bind(this ,  this.props.vocab.learningAudio)} >
                            <CDNImage size={15} src="img/audioWordPod.png"/></span></ListGroupItem>
                <ListGroupItem>{this.props.vocab.originalWord}     <span className="pull-right" onClick={this.playAudio.bind(this ,  this.props.vocab.audio)}><CDNImage size={15} src="img/audioWordPod.png"/></span></ListGroupItem>
            </ListGroup>
            <br />
            {buttons}
        </Thumbnail>
    }

}


// WEBPACK FOOTER //
// ./src/components/content-vocab.js